export function alipayReady (cb) {
  let bridge = global.AlipayJSBridge
  if (typeof bridge !== 'undefined') {
    cb(bridge)
  } else {
    document.addEventListener('AlipayJSBridgeReady', (bridge) => {
      cb(bridge)
    })
  }
}
